import { createParams } from 'api/api-utils';
import { CancelToken } from 'axios';
import { basicDefaultState, BasicFilter, getBreedOrDefault } from 'pages/search/filters/all/basic';
import { individualDefaultState } from 'pages/search/filters/individual/individual-utils';
import { IndividualFilter } from 'pages/shared/individual-filter.enum';
import queryApi from '../query-api';
import {
  addCustomASBVs, getFilterParams, getParamsByAsbvFilter, getParamsByFilter
} from '../query-utils';
import { ExportFilters } from './export-filters';

class ExportApi {
  private resource = 'export';

  /**
   * Exports results.
   * It combines `getByIndividual`, `getByCriteria` and `getByIds` search api calls.
   */
  export = async (filters: ExportFilters, searchTitle: string, token?: CancelToken) => {
    let paramsFilters;

    if (filters.animalIds) {
      paramsFilters = { [IndividualFilter.AnimalId]: filters.animalIds };
      if (filters.customASBV) {
        paramsFilters = { ...paramsFilters, ...addCustomASBVs(filters.customASBV) };
      }
    } else if (filters.filters) {
      paramsFilters = {
        ...getFilterParams(filters.dbType, filters.userType, filters.scenario, filters.catalogueId),
        ...getParamsByFilter(filters.filters.individual, individualDefaultState),
        ...getParamsByFilter(filters.filters.basic, basicDefaultState),
        ...getParamsByAsbvFilter(filters.filters.asbv),
        ...getParamsByFilter(filters.filters.pedigree),
        ...getParamsByFilter(filters.filters.progeny),
        [BasicFilter.Breed]: getBreedOrDefault(filters.dbType, filters.filters.basic),
      };
      if (filters.customASBV) {
        paramsFilters = { ...paramsFilters, ...addCustomASBVs(filters.customASBV) };
      }
    } else {
      paramsFilters = undefined;
    }

    const searchTitleObject = { searchTitle };


    let params = createParams({
      ...getFilterParams(filters.dbType, filters.userType, filters.scenario, undefined, undefined, undefined, undefined, filters.catalogueId),
      ...paramsFilters,
    })

    params = { ...params, ...searchTitleObject };


    const response = await queryApi.get(
      `/${this.resource}`,
      {
        params,
        cancelToken: token,
      },
    );
    return response;
  }
}

export default new ExportApi();
